import Vue from 'vue'
import Vuex from 'vuex'

// modules
import auth from './modules/auth';
import chat from './modules/chat';
import settings from './modules/settings';
import sidebar from './modules/sidebar';

Vue.use(Vuex);

//Globals var..
Vue.$lastSearchCustomers = '';
Vue.$lastSearchServices = '';
Vue.$lastSearchProducts = '';
Vue.$lastSearchCategories = '';
Vue.$StoreMenu = {};
Vue.$startupPath = "";

//Vue.$urlImgNoPic = 'https://afs.googleusercontent.com/gumtree-com/noimage_thumbnail_120x92_v2.png';
Vue.$urlImgNoPic = '/static/img/no-picture.png';

export const store = new Vuex.Store({
    modules: {
        auth,
        chat,
        settings, 
        sidebar
    }
})
